<template>
  <div>

    <cc-collapse v-if="config" :title="$t('ct-general-settings')">
      <div class="form-group">
        <label for="url">{{ $t('ct-url') }}</label>
        <input id="url" :type="href[config.type].type" v-model="config.href" class="form-control" @input="save()" @change="save()"
          :placeholder="$t(href[config.type].placeholder)">
        <span class="fs-6">{{ 'Ex: ' + href[config.type].ex }}</span>
      </div>
      <div class="form-group">
        <label for="call-to-action">{{ $t('ct-call-to-action') }}</label>
        <input id="call-to-action" type="text" class="form-control" v-model="config.callToAction.text" maxlength="35" :disabled="!config.callToAction.enable" @input="save()" @change="save()">

        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="config.callToAction.enable" name="enable" @change="save()">
          <label class="form-check-label">
            {{ $t('ct-enable') }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="">{{ $t('ct-position') }}</label>
        <div class="form-check">
          <input class="form-check-input" type="radio" v-model="config.right" name="left" :value="false" @change="save()">
          <label class="form-check-label">
            {{ $t('ct-left') }}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" v-model="config.right" name="right" :value="true" @change="save()">
          <label class="form-check-label">
            {{ $t('ct-right') }}
          </label>
        </div>
      </div>
    </cc-collapse>

    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-opacity')">
      <cc-slider-component ref="opacity"></cc-slider-component>
    </cc-collapse>

     <cc-collapse :title="$t('ct-shadow')">
      <cc-shadow ref="shadow"></cc-shadow>
    </cc-collapse>

    <cc-collapse :title="$t('ct-animation')">
      <cc-animation ref="animation"></cc-animation>
    </cc-collapse>

    <cc-collapse :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

  </div>
</template>

<script>
export default {
  name: 'Options',
  data() {
    return {
      config: {
        type: 'whatsapp',
        href: '',
        callToAction: {
          enable: false,
          text: '',
        },
        right: false
      },
      callback: () => { },
      href: {
        'whatsapp': { ex: ' https://wa.me/18001234567', placeholder: 'ct-phone-number', type: 'text', url: null },
        'linkedin': { ex: 'https://linkedin.com/in/profile', placeholder: 'ct-linkedin-profile-link', type: 'text', url: null },
        'instagram': { ex: 'https://ig.me/m/user_name', placeholder: 'ct-user-name', type: 'text', url: null  },
        'email': { ex: 'company@example.com', placeholder: 'ct-email', type: 'text', url: null },
        'messenger': { ex: 'http://m.me/PAGE-NAME', placeholder: 'ct-facebook-page-name', type: 'text', url: null },
        'youtube': { ex: 'https://youtube.com/watch?v=Q_s_7iTydYU', placeholder: 'ct-video-link', type: 'text', url: null },
        'x': { ex: 'https://x.com/elonmusk', placeholder: 'ct-x-account', type: 'text', url: null },
        'custom': { ex: 'www.domainexample.com', placeholder: 'ct-link-anchor', type: 'text', url: null }
      }
    };
  },
  watch: {
    'config.callToAction': {
      handler(value) {
        this.config.callToAction.text = !value.text.length ? this.$t('ct-send-us-a-message') :  this.config.callToAction.text;
        this.save()
      },
      deep: true
    }
  },
  // computed: {
  //   link: {
  //     // getter
  //     get() {
  //       return this.config.href
  //     },
  //     // setter
  //     set(newValue) {
  //       this.config.href = this.href[this.config.type].email ? this.href[this.config.type].url.replace('X', newValue) : newValue;
  //     }
  //   }
  // },
  methods: {
    init(config, callback) {
      let vm = this;
      vm.config = _.clone(config);
      vm.callback = callback;

      this.$refs['widthConfig'].setValues({ defaultValue: vm.config.width, defaultValueChecked: true, min: 50, max: 100, canBeCheckbox: false, labelDesc: 'width', name: 'iconColor', callback: vm.setWidth });

      this.$refs['opacity'].setValues({ defaultValue: vm.config.opacity * 100, defaultValueChecked: true, min: 1, max: 100, canBeCheckbox: false, labelDesc: 'opacity', name: 'opacity', callback: vm.setOpacity });

      // shadow
      this.$refs['shadow'].setValues({defaultValue: vm.config.boxShadow, labelDesc: 'shadow', name: 'shadow', callback: vm.setShadow});

      // animation
      this.$refs['animation'].setValues({
        action: vm.config.animation.in.action,
        effect: vm.config.animation.in.effect,
        scroll: vm.config.animation.in.scroll,
        time: vm.config.animation.in.time,
        speed: vm.config.animation.in.speed,
        infinite: vm.config.animation.in.infinite,
        labelDesc: 'animate',
        name: 'animate',
        callback: vm.setAnimation
      }, null);

      // tag
      this.$refs['tag'].setValues({ tag: vm.config.tag, callback: vm.setTag });

    },
    setOpacity(value) {
      this.config.opacity = value / 100;
      this.save();

    },
    setShadow(data) {
      this.config.boxShadow = `${data.h}px ${data.v}px ${data.b}px ${data.s}px ${data.color}  ${data.inset ? 'inset' : ''}`;
      this.save();
    },
    setWidth(value) {
      this.config.width = `${value}px`;
      this.save();
    },
    setAnimation(data) {
      this.config.animation.in = _.merge(this.config.animation.in, data);
      this.save();
    },
    setTag(value) {
      this.config.tag = value;
      this.save();
    },
    save() {
      this.callback(this.config);
    }
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => { };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/editor/apps/FloatingButton/Options.vue